import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyContactCollectorIframe = loadable(() => import(/* webpackChunkName: "content/contactCollector/iframe" */ '.'));
